import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmationModal = (props) => {
  const {
    isVisible,
    heading,
    message,
    confirmBtnHandler,
    confirmBtnText,
    cancelBtnHandler,
    cancelBtnText
  } = props;

  return (
    <Modal className="filter-model PlanStatusModel" show={isVisible} onHide={isVisible} centered>
      <Modal.Header>
        <Modal.Title className="w-100">
          <h5 className="modal-title text-center w-100">{heading}</h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>

        <div>
          <div className="text-center">
            <button type="button" className="btn theme-btn themebtn1 mr-0" onClick={confirmBtnHandler}>
              {confirmBtnText}
            </button>
          </div>

          <div className="text-center">
            <button type="button" className="btn theme-btn themebtn2" onClick={cancelBtnHandler}>
              {cancelBtnText}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
